import { TMCTableModule } from '@sdbn/common';
import { ServiceResponseModule } from '@sdbn/common';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WeighTransportDialogComponent } from './component/weigh-transport-dialog.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule as MatInputModule } from '@angular/material/input';
import { ApplicationClientCommonModule } from '@sdbn/common';
import { TransportInfoPanelModule } from '@sdbn/common';
import { CommonTranslationModule } from '@sdbn/common';
import { MatTooltipModule as MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule as MatSelectModule } from '@angular/material/select';

@NgModule({
  imports: [
    CommonModule,

    FormsModule,
    MatInputModule,
    ReactiveFormsModule,
    TransportInfoPanelModule,
    TMCTableModule,
    ApplicationClientCommonModule,
    ServiceResponseModule,
    CommonTranslationModule,
    MatTooltipModule,
    MatSelectModule
  ],
  declarations: [WeighTransportDialogComponent]
})
export class TransportWeighingModule { }
